import { useContext } from "react";
import { useStore } from "zustand";
import { CollectionDropContext } from "./CollectionDropContext";
export const useDropStore = selector => {
  const context = useContext(CollectionDropContext);
  if (!context) {
    throw new Error("useDropStore must be used within a CollectionDropProvider");
  }
  return useStore(context, selector);
};